import { UserManager, WebStorageStateStore } from "oidc-client";
import { API_BASE_URL } from "../../config";
import { clearAllCookies } from "../extensions/clearAllCookies";

const config = {
  authority: API_BASE_URL + "/api",
  redirect_uri: `${window.location.origin}/authorize-redirect`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  silent_redirect_uri: `${window.location.origin}/silent-renew.html`,
  response_type: "code",
  scope: "openid profile email api1 offline_access",
  loadUserInfo: true,
  response_mode: "query",
  client_id: "teamrayclient",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  stateStore: new WebStorageStateStore({ store: window.localStorage }),
  sessionMonitor: false,
  automaticSilentRenew: true,
  accessTokenExpiringNotificationTime: 1800, // 30 minutes before token expiry
};

const userManager = new UserManager(config);

let isLoginRedirect = false;

userManager.events.addUserLoaded(async (user) => {
  if (isLoginRedirect) {
    isLoginRedirect = false;
  }

  window.dispatchEvent(new CustomEvent("oidc-token-refreshed", { detail: user }));
});

userManager.events.addSilentRenewError((error) => {
  console.error("❌ Silent renew failed:", error);
  window.dispatchEvent(new CustomEvent("oidc-silent-renew-error", { detail: error }));
});

userManager.events.addAccessTokenExpired(async () => {
  try {
    await userManager.signinSilent();
  } catch (error) {
    console.error("❌ Failed to refresh token after expiry:", error);
    window.dispatchEvent(new CustomEvent("oidc-silent-renew-error", { detail: error }));
  }
});

export const login = async (provider: "Google" | "Microsoft" | "Facebook") => {
  try {
    clearAllCookies();
    const scopes =
      provider === "Facebook"
        ? "openid email"
        : "openid profile email api1 offline_access";
    await userManager.signinRedirect({
      extraQueryParams: { prompt: "login", provider: provider },
      scope: scopes,
    });
  } catch (error) {
    throw error;
  }
};

export const getUser = async () => {
  const user = await userManager.getUser();
  if (user) {
    if (!user.expired) {
      startSilentRenew();
    }
    
  }
  return user;
};

export const startSilentRenew = () => {
  userManager.startSilentRenew();
};

export const stopSilentRenew = () => {
  userManager.stopSilentRenew();
};

export const refreshToken = async () => {
  try {
    const user = await userManager.signinSilent();
    if (user) {
      return user;
    }
    return null;
  } catch (error) {
    console.error("❌ Token refresh failed:", error);
    window.dispatchEvent(new CustomEvent("oidc-silent-renew-error", { detail: error }));
    throw error;
  }
};

export const completeSignIn = async () => {
  try {
    isLoginRedirect = true;
    await userManager.signinRedirectCallback();
  } catch (error) {
    isLoginRedirect = false;
    throw error;
  }
};

export default userManager;
